module.exports = __webpack_public_path__ + "static/media/paper.b6655564.png";